module.exports = __webpack_public_path__ + "static/img/28.0125956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/28.png
// module id = /ygY
// module chunks = 0